var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33464 11.3333L13.2513 6.41667C13.4041 6.26389 13.5985 6.1875 13.8346 6.1875C14.0707 6.1875 14.2652 6.26389 14.418 6.41667C14.5707 6.56944 14.6471 6.76389 14.6471 7C14.6471 7.23611 14.5707 7.43056 14.418 7.58333L8.91797 13.0833C8.7513 13.25 8.55686 13.3333 8.33464 13.3333C8.11241 13.3333 7.91797 13.25 7.7513 13.0833L5.58464 10.9167C5.43186 10.7639 5.35547 10.5694 5.35547 10.3333C5.35547 10.0972 5.43186 9.90278 5.58464 9.75C5.73741 9.59722 5.93186 9.52083 6.16797 9.52083C6.40408 9.52083 6.59852 9.59722 6.7513 9.75L8.33464 11.3333Z",
    fill: "#9AE6B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPricing);
export default __webpack_public_path__ + "static/media/CheckPricing.36f4bc062758de2ced5d57c4e3a3d8ee.svg";
export { ForwardRef as ReactComponent };